import { SET_LOADING, SET_PROGRESS } from '../types/loader';

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setProgress = (progress) => ({
  type: SET_PROGRESS,
  payload: progress,
});